import React from 'react';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        Sentry.captureException(error);
        Sentry.captureMessage(errorInfo.componentStack, Sentry.Severity.Error);
        // You can also log error messages to an error reporting service here
    }

    render() {

        if (this.state.errorInfo) {
            // Error path
            return (
                <div>
                    <div style={{ justifyContent: 'center', alignItems: 'center' }}>Uh Oh!</div>
                    <div style={{ fontWeight: 'bold' }}>
                        Something went wrong. If you receive this message, please contact us immediately so we can investigate and resolve the issue for you.
                    </div>
                    {(this.state.error && process.env.REACT_APP_ENVIRONMENT !== 'PRODUCTION') && <div>{this.state.error.toString()}</div>}
                    {(process.env.REACT_APP_ENVIRONMENT !== 'PRODUCTION') ? (<div>{this.state.errorInfo.componentStack}</div>) : null}
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;